import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, defer, of, retry, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

const MAX_RETRY_ATTEMPTS = 3;
const RETRY_HEADER = 'X-Retryable-With-Session';
const NO_SESSION_STATUS = 202;

class RetryWithSession {
  constructor(public readonly response: HttpResponse<unknown>) {}
}

export const missingWebshopSessionInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  return defer(() => next(req)).pipe(
    switchMap((event) => {
      if (event instanceof HttpResponse && needsSessionRetry(event)) {
        return throwError(() => new RetryWithSession(event));
      }
      return of(event);
    }),
    retry({
      count: MAX_RETRY_ATTEMPTS,
      delay: (error) => {
        if (!(error instanceof RetryWithSession)) {
          throw error;
        }
        return defer(() => auth.createSession());
      },
    }),
    catchError((error: unknown) => {
      if (error instanceof RetryWithSession) {
        return of(error.response);
      }
      throw error;
    }),
  );
};

function needsSessionRetry(event: HttpResponse<unknown>): boolean {
  return event.status === NO_SESSION_STATUS && event.headers.get(RETRY_HEADER) === 'true';
}
